import React from 'react'

function NotFound() {
  return <p>What you looking is not here 404</p>
}

export default NotFound
